<template>
    <div class="media-details">
        <h1>{{ title }}</h1>


        <div class="details">
            <div class="column column-1">
                <div>
                    <h2 class="column-title">Photo Details</h2>

                    <ul class="details-list">
                        <Li label="File Name" :content="details.fileName"/>

                        <Li label="Date Created" :content="details.date"/>

                        <Li label="Photographer" :content="details.author.name"/>

                        <Li label="Email" :content="makeClickable(details.author.work_email)"/>

                        <Li label="Website" :content="makeClickable(details.author.url)"/>

                        <Li label="Event" :content="details.events"/>

                        <Li label="Location" :content="[...details.city, ...details.province_state]"/>

                        <Li label="Sublocation" :content="details.sublocation"/>

                        <Li label="Person Shown" :content="details.person_in_image"/>

                        <Li label="Copyright" :content="details.copyright"/>

                        <Li label="Copyright Info" :content="details.copyright_notice"/>

                        <Li label="Right Usage Terms" :content="details.usage_terms"/>
                    </ul>
                </div>
            </div>

            <div class="column column-2">
                <div>
                    <h2 class="column-title">Camera Specs</h2>
                    <ul class="details-list">
                        <Li label="Make" :content="details.camera.make"/>

                        <Li label="Model" :content="details.camera.model"/>

                        <Li label="Lens" :content="details.camera.lens"/>

                        <Li label="Exposure"
                            :content="details.camera.exposure + (details.camera.FNumber ? ` at f/${details.camera.FNumber}` : '')"
                            :conditional="details.camera.exposure"/>

                        <Li label="Focal" Length :content="`${details.camera.focal }mm`"
                            :conditional="details.camera.focal"/>

                        <Li label="Focal Length 35mm" :content="`${details.camera.focal_35mm }mm`"
                            :conditional="details.camera.focal_35mm"/>

                        <Li label="ISO Speed Rating" :content="`ISO ${details.camera.iso}`"
                            :conditional="details.camera.iso"/>

                        <Li label="Flash" :content="details.camera.flash ? 'Yes' : 'Did not fire'"/>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import MapBox from './MapBox';
import {default as Li} from "./MediaDetailsListItem";

export default {
    name: "MediaDetails",

    components: {
        Li,
        MapBox
    },

    props: [
        'media',
        'title'
    ],

    data() {
        return {};
    },

    computed: {
        details() {
            return this.media.details;
        }
    },

    methods: {
        makeClickable(inputText) {
            if (!inputText) {
                return '';
            }

            //URLs starting with http://, https://, or ftp://
            const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
            inputText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

            //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
            const replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
            inputText = inputText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

            //Change email addresses to mailto:: links.
            const replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
            inputText = inputText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

            return inputText;
        }
    }
}
</script>

<style lang="scss" scoped>
.media-details {
    height: 0;
    overflow: hidden;
    padding: 1rem;
    transition: all 0.3s ease-in-out;
    visibility: hidden;

    > h1 {
        text-align: center;
        margin-top: 1rem;
        margin-bottom: 1rem;
        font-size: 1.7rem;
    }
}

.has-details .media-details {
    height: 80%;
    overflow: auto;
    visibility: visible;

    .media-details-box {
    }
}


.details {
    > * > div {
        padding: 1rem;
        background: #fafafa;
        border: 1px solid #cecece;
        margin-bottom: 1rem;
    }
}

@media all and (min-width: 768px) {
    .details {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto auto auto;
        gap: 1rem;
        grid-template-areas:
    "column-1 column-2"
    "column-1 map";

        > * > div {
            margin: 0;
        }
    }
}

.column-title {
    margin-bottom: 1rem;
    font-size: 1.5rem;
    text-transform: capitalize;
}

.column-1 {
    grid-area: column-1
}

.column-2 {
    grid-area: column-2
}

.map {
    grid-area: map
}

.details-list > li:not(:last-child) {
    margin-bottom: .5rem;
}

.file-name {

}
</style>